import { Grid, Tab, Tabs } from "@mui/material"
import { useState } from "react";
import styles from '../../Styles/ComponentStyles/ProfileStyle/ProfileDetails.module.scss'
import SAndPComparisonTab from "../Profile/IULProfileTabs/SAndPComparisonTab/SAndPComparisonTab";
import AccValueTab from "../Profile/IULProfileTabs/AccValueTab/AccValueTab";
import RetirementIncomeTab from "../Profile/IULProfileTabs/RetirementIncomeTab/RetirementIncomeTab";
import TaxesTab from "../Profile/IULProfileTabs/TaxesTab/TaxesTab";
import FeesTab from "../Profile/IULProfileTabs/FeesTab/FeesTab";
import GlobalTabsComponent from "../../GlobalComponent/GlobalTabsComponent/GlobalTabsComponent";

const IULOutput = () => {
    const [tabNavigationvalue, setTabNavigationValue] = useState<string>('1');

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabNavigationValue(newValue);
    };

    return (
        <>
            <Grid container>
                <Grid item xs={12}
                    sx={{
                        backgroundColor: "#fff",
                        padding: "0px 20px",
                        borderBottom: "1px solid #E2E8F0"
                    }}
                >
                    <GlobalTabsComponent
                        value={tabNavigationvalue || '1'}
                        onChange={handleTabChange}
                        tabs={[
                            { label: "S&P Comparison", value: "1" },
                            { label: "Account Value", value: "2" },
                            { label: "Retirement Income", value: "3" },
                            { label: "Taxes", value: "4" },
                            { label: "Fees", value: "5" },
                        ]}
                    />
                </Grid>
                <Grid item xs={12} padding={"20px"}>
                    {
                        tabNavigationvalue == "1" && <SAndPComparisonTab />
                    }
                    {
                        tabNavigationvalue == "2" && <AccValueTab />
                    }
                    {
                        tabNavigationvalue == "3" && <RetirementIncomeTab />
                    }
                    {
                        tabNavigationvalue == "4" && <TaxesTab />
                    }
                    {
                        tabNavigationvalue == "5" && <FeesTab />
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default IULOutput
